export default "__VITE_ASSET__gZbpf2Qh__"